import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import { EditDishContext, IEditDishContext } from '../../../../../../editDishState/editDishContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		selectedCustomer,
		totalPrices,
		restaurantWithTurnOffComment,
		restaurantWithRequiredComment,
		shortDescription,
		selectedComboModifier,
		externalId,
		isDisabledInRestaurants,
		translations,
		activationSchedule,
		deactivationSchedule,
		selectedModifierGroups,
		modifierGroupsWithAdditionalData,
		selectedModifierGroupsAsAdditional,
		selectedSuggestedDishes,
		selectedAdditionalDishes,
		selectedDishModifications,
		IDsShowInComboDishes,
		posName,
		filePath,
		fileId,
		smallFilePath,
		smallFileId,
		videoPath,
		videoFileId,
		isTaxPercentProtectedFromSync,
		taxPercent,
		hasOpenPrice,
		openPrice,
		openPriceMaxThreshold,
		isFiscalized,
		initialFormData,
	} = useContext<IEditDishContext>(EditDishContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: name || totalPrices.length || shortDescription,
	});

	const currentFormData = {
		name,
		selectedCustomer,
		totalPrices,
		restaurantWithTurnOffComment,
		restaurantWithRequiredComment,
		shortDescription,
		selectedComboModifier,
		externalId,
		isDisabledInRestaurants,
		translations,
		activationSchedule,
		deactivationSchedule,
		selectedModifierGroups,
		modifierGroupsWithAdditionalData,
		selectedModifierGroupsAsAdditional,
		selectedSuggestedDishes,
		selectedAdditionalDishes,
		selectedDishModifications,
		IDsShowInComboDishes,
		posName,
		isTaxPercentProtectedFromSync,
		taxPercent,
		hasOpenPrice,
		openPrice,
		openPriceMaxThreshold,
		isFiscalized,
		filePath: fileId || filePath || null,
		smallFilePath: smallFileId || smallFilePath || null,
		videoPath: videoFileId || videoPath || null,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
